import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GlobalService } from './global.service';
import { map, catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
import { LocalStorageService } from './local-storage.service';

const devUrl = environment.backendurl;

export interface PersonSearchListing {
  name: string;
  count: number;
  meta: any;
}

export interface PersonSearchRecommendCandidatesRequest {
  startindex: number;
  resultsize: number;
  searchviaboolean: boolean;
  booleanquery: string;
  currentjobtitle: boolean;
  currentcompaniesonly: boolean;
  pastcompaniesonly: boolean;
  jobtitles: string[];
  preferredskills: string[];
  mandatoryskills: string[];
  locations: string[];
  companies: string[];
  industries: string[];
  exclusionlist: string[];
  genders: string[];
  schools: string[];
  schooltypes: string[];
  educationaldegrees: string[];
  educationalmajors: string[];
  candidateshavingemails: boolean;
  candidateshavingcontactnumbers: boolean;
  minexperience: number;
  maxexperience: number;
  minexperienceinccurrentcompany: number;
}

export interface PersonSearchRecommendCandidatesResponse {
  status: string;
  data: {
    totalresultscount: number;
    results?: RecommendCandidateResult[];
    elasticsearchquery?: {}
  }
}

export interface RecommendCandidateResult {
  persondetails: PersonDetails;
  matchscore: number;
}

export interface PersonDetails {
  id: string;
  full_name: string;
  first_name: string;
}

export interface Similarobject {
  jobtitle: { key: string, isMandatory: boolean }[] | [];
  jobcompanyname: { key: string, isMandatory: boolean }[] | [];
  jobindustryname: { key: string, isMandatory: boolean }[] | [];
  pastindustries: string[];
  schools:  { key: string, isMandatory: boolean }[] | string[];
  currentlocation: { key: string, isMandatory: boolean }[] | [];
  skills: { key: string, isMandatory: boolean }[] | [];
  elasticid: string | number;
  companysize: { key: string, isMandatory: boolean }[] | [];
  fullname: string;
  totaltenure?: string | number;
  linkedinurl: string;
  isUploadedFromResume: boolean;
  locationregion: string;
  locationcontinent: string;
  fromYrsOfExperience?: string | number;
  toYrsOfExperinece?: string | number;
}

@Injectable({
  providedIn: 'root'
})
export class PersonSearchService {
  public recommendcandidates: any
  Similarobject: any;
  private companyDetailSubject = new BehaviorSubject<any>({});
  private talentinsightssubject = new BehaviorSubject<any>({});
  private companyinsightsfilterai = new BehaviorSubject<any>({});
  private talentinsightsfilterai= new BehaviorSubject<any>({})
  private insightsdata= new BehaviorSubject<any>({})
  private geoIpLocationOfUser = new BehaviorSubject<any>(this.locaStorageService.getItem('userGeoIpLocation') ? JSON.parse(this.locaStorageService.getItem('userGeoIpLocation')) : {});
  
  companyDetailNext(data: any) {
    this.companyDetailSubject.next(data);
  }

  get companyDetail(): Observable<any> {
    return this.companyDetailSubject.asObservable();
  }

  setTalentinsights(data: any) {
    this.talentinsightssubject.next(data);
  }

  get gettalentinsights(): Observable<any> {
    return this.talentinsightssubject.asObservable();
  }

  setCompanyInsightsFilterAI(data: any) {
    this.companyinsightsfilterai.next(data);
  }

  get getcompanyinsightsfilterAI(): Observable<any> {
    return this.companyinsightsfilterai.asObservable();
  }

  setTalentinsightsFilterAI(data: any) {
    this.talentinsightsfilterai.next(data);
  }

  get getTalentinsightsFilterAI(): Observable<any> {
    return this.talentinsightsfilterai.asObservable();
  }

  setquicksearchinsightsdata(data: any) {
    this.insightsdata.next(data);
  }

  get getquicksearchinsightsdata(): Observable<any> {
    return this.insightsdata.asObservable();
  }

  get getGeoIpLocationOfUser(): Observable<any> {
    return this.geoIpLocationOfUser.asObservable();
  }

  setGeoIpLocationOfUser(data: any) {
    this.geoIpLocationOfUser.next(data);
  }

  constructor(private http: HttpClient, private locaStorageService: LocalStorageService) { }

  /**
   * Get Person Search Listing
   * @param keyword
   * @returns PersonSearchListing[]
   */
  getPersonSearchListing(keyword: string,type: string = null,continent?: string ): Observable<PersonSearchListing[]> {
    let url = devUrl + "/personsearch/typeaheads"
    const queryParams = { keyword: keyword };
    type && (queryParams['type'] = type);
    if(continent) queryParams['continent'] = continent;
    return this.http.get<PersonSearchListing[]>(url, { params: queryParams }).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Get Person Search Listing', url)))
  }


  getPersonSearchRecommendCandidates(requestObject: any): Observable<any> {
    let url = devUrl + "/personsearch/recommendcandidates";
    return this.http.post<any>(url, requestObject).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  getCandidateInsights(): Observable<any> {
    const url = devUrl + '/personsearch/allcandidatesinsights';
    return this.http.get<any>(url).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Get Person Search Listing', url)));

  }

  getTalentPoolBucketList(): Observable<any> {
    const url = devUrl + '/personsearch/talentpoolbucketslist';
    return this.http.get<any>(url).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  getRefreshedCandidate(candidateObject): Observable<any> {
    const url = devUrl + '/personsearch/refreshcandidatedata';
    return this.http.put<any>(url, candidateObject).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  getTotalAggs(requestobject):  Observable<any> {
    const url = devUrl + '/personsearch/aggregates';
    return this.http.post<any>(url, requestobject).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  getSearchHistory(startindex): Observable<any> {
    const url = devUrl + `/personsearch/searchhistory?startindex=${startindex}`;
    return this.http.get<any>(url).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  getSaveSearchHistory(startindex, talentdiscoveryhistoryid: string = null): Observable<any> {
    const url = devUrl + `/personsearch/savedsearchhistory?startindex=${startindex}`;
    return this.http.get<any>(url, { params: talentdiscoveryhistoryid ? { talentdiscoveryhistoryid } : {} }).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  checkSearchNameDuplicacy(searchname: string): Observable<any> {
    const url = devUrl + `/personsearch/search/name/duplicate?name=${searchname.trim()}`;
    return this.http.get<any>(url).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Check save search name duplicacy', url)));
  }

  saveSearch(payload: any, update: boolean = false): Observable<any> {
    let url = devUrl + `/personsearch/search/save`;
    let queryParams = new HttpParams();
    if(update) {
      queryParams = queryParams.append('update', 'true');
      url = url + '?' + queryParams.toString();
    }

    return this.http.put(url, payload).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Save search', url)));
  }

  getdetailsfromlinkedin(linkedinurl:any): Observable<any> {
    const url = devUrl + `/personsearch/detailsfromlinkedinurl?linkedinurl=${linkedinurl}`;
    return this.http.get<any>(url).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }
  previewContactDetails(elasticid): Observable<any> {
    const url = devUrl + `/personsearch/previewcontactdetails?elasticid=${elasticid}`
    return this.http.get<any>(url).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  revealContact(data) : Observable<any> {
    const url = devUrl + '/personsearch/revealcontact';
    return this.http.put<any>(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  addToTanentpool(data):  Observable<any> {
    const url = devUrl + '/personsearch/addtotalentpool';
    return this.http.post<any>(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  markContactValidity(payload): Observable<any> {
    const url = devUrl + '/candidate/contact/validate';
    return this.http.put<any>(url, payload).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Mark contact validity', url)));
  }

  getrecordsCount(): Observable<any> {
    const url = devUrl + `/personsearch/recordscount`
    return this.http.get<any>(url).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person record count', url)));
  }


  

  public passsimilarcandidatesdata (data): void {
    this.recommendcandidates = data;
    setTimeout(() => {
      this.recommendcandidates = []
    },2000)
  }
  
  public getsimilarcandidatesdata (){
    return this.recommendcandidates;
  }

  parseresume(data) {
    let formData: FormData = new FormData();
    formData.append('resume', data);
    var url = devUrl + "/personsearch/parseresume"
    return this.http.post(url, formData).pipe(
      map(response => { return response; })
      , catchError(GlobalService.handleError('Resume Parsing', url)));
  }

  getRecentAttritionData(requestObject): Observable<any> {
    const url = devUrl + '/personsearch/recentcompanyattrition';
    return this.http.post(url, requestObject).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  getKeyPeople(requestObject): Observable<any> {
    const url = devUrl + '/personsearch/detailsfrompdlids';
    return this.http.post<any>(url, { ...requestObject }).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  getRecentHires(requestObject): Observable<any> {
    const url = devUrl + '/personsearch/recentcompanyhires';
    return this.http.post(url, requestObject).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  getBooleanQuery(data): Observable<any> {
    const url = devUrl + '/personsearch/booleanquery';    
    return this.http.post<any>(url, data ).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Boolean Query', url)));
  }

  saveProfileView(data):  Observable<any> {
    const url = devUrl + '/personsearch/saveprofileview';    
    return this.http.put<any>(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Boolean Query', url)));
  }

  
  getCompanyLogo(data): Observable<any> {
    const url = devUrl + '/personsearch/companylogo';
    return this.http.post<any>(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  /**
   * Export candidate profile in PDF
   * @param payload 
   */
  exportCandidateProfileToPDF(payload: { elasticid?: string, candidatenumber?: string }): Observable<any> {
    const url = devUrl + '/personsearch/candidate/export';
    return this.http.post(url, payload, { responseType: 'blob' }).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  
  makeRequestContact(requestObject: any): Observable<any> {
    const url = devUrl + "/personsearch/candidateintroduction";
    return this.http.post<any>(url, requestObject).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('Error while making contract request', url)));
  }

  getCandidateActivity(elastic_id): Observable<any> {
    const url = devUrl + `/personsearch/candidateactivity?elastic_id=${elastic_id}`;
    return this.http.get<any>(url).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person record count', url)));
  }


  getLastCandidateActivity(elastic_id): Observable<any> {
    const url = devUrl + `/personsearch/lastcandidateactivity?elastic_id=${elastic_id}`;
    return this.http.get<any>(url).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person record count', url)));
  }

  getCandidateActivityInBulk(elastic_ids): Observable<any> {
    const url = devUrl + `/personsearch/bulkcandidateactivity?elastic_id=${elastic_ids}`;
    return this.http.get<any>(url).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person record count', url)));
  }
  gettalentinsightssummary(requestObject): Observable<any> {
    const url = devUrl + '/openai/talentinsightssummary';
    return this.http.post(url, requestObject).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  getquicksearchsummary(requestObject): Observable<any> {
    const url = devUrl + '/openai/quicksearchsummary';
    return this.http.post(url, requestObject).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  /**
   * Company Attrition data, 
   * @param data 
   * @returns 
   */
  getCompanyAttrition(data): Observable<any> {
    const url = devUrl + '/company/attrition';
    return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  /**
   * Company Growth data
   * @param data 
   * @returns 
   */
  getCompanyGrowth(data): Observable<any>{
    const url = devUrl + '/company/growth';
    return this.http.post(url, data).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }
}
